<template>
	<div class="heads" style="background: #fff;">
		<div class="big-center">
			<div class="center">
				<el-row :gutter="20">
					<el-col :span="11">
						<div class="top-left">
								<div class="logoname">{{ $t('navbar.welcomes') }}</div>
							<div class="logins">
								<span v-if="!userId" @click="goAbute('/login')">{{ $t('navbar.login') }}</span>
								<span v-if="!userId" class="xian">|</span>
								<span v-if="!userId" @click="goAbute('/login?navgatorIndex=3&registerType=email')">{{ $t('navbar.registration') }}</span>
								<span v-if="userId" @click="quit()">{{ $t('navbar.quit') }}</span>
							</div>
						</div>
					</el-col>
					<el-col :span="13">
						<div class="top-right">
								<span @click="goAbute('/?index=0')">{{ $t('navbar.homePage') }}</span>
								<span @click="goShoppingCar('/order')">{{ $t('navbar.personal') }}</span>
								<span>
									<span @click="goChat()" class="el-dropdown-link" style="color: #999;">
										{{ $t('navbar.contactService') }}
									</span>
								</span>
								<!-- <span @click="goAbute('/shoppingGuide')" style="color: #999;">购物须知</span> -->
						
			
							<!-- <span >
								<el-dropdown>
									<span class="el-dropdown-link" style="color: #999;">
										{{ $t('navbar.mobile') }}<i class="el-icon-arrow-down el-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item>
											<img style="height: 100px;width: 100px;" :src="QRcode" />
										</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
								
							</span> -->
							<Lang class="right-menu-item" style="margin-left: 20px;"></Lang>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="big-centers">
			<div class="center">
				<div class="cons left" @click="goHome()" >
					<img src="../assets/head/logo.png"/>
				</div>
				<div class="search-list" style="display: inline-block;width: 48%;">
					<div v-for="(item,index) in data" :key="index" :class="index<=5?'one':'four'"
						 @click="goAbute('/productList?title=' + item	)">
						{{item}}
					</div>
				</div>
				<div class="cons cont">
					<div class="searchs" @click="goAbute('/productList')" style="position: relative;">
						<el-input :placeholder="$t('navbar.contentSearch')" v-model="value"  @keydown.enter.native="sousuo(value)" class="input-with-select">
							<!-- <el-button slot="append" icon="el-icon-search" @click="sousuo()">{{ $t('navbar.search') }}</el-button> -->
						</el-input>
						<i class="el-icon-search" @click="sousuo(value)" style="position: absolute;bottom: 12px;right: 10px;color: #999;"></i>
					</div>
					<!-- <div class="search-list">
						<div v-for="(item,index) in data" :key="index" :class="index<=2?'one':'four'"
							 @click="goAbute('/productList?title=' + item)">
							<span v-if="index==0" class="re bao">HOT</span>
							<span v-if="index==1||index==2" class="re">HOT</span>
							{{item}}
						</div>
					</div> -->
				</div>
				<div class="cons right">
					<div class="myCars">
						<el-badge v-if="dataC" :value="dataC.length" class="item">
							<img class="carimg" src="../assets/head/card.png" />
							<span class="myCar" @click="goShoppingCar('/shoppingCar')">{{ $t('navbar.myCart') }}</span>
						</el-badge>
						<div v-else>
							<img class="carimg" src="../assets/head/card.png" />
							<span class="myCar" @click="goShoppingCar('/shoppingCar')">{{ $t('navbar.myCart') }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Head',
	props: {
		data: [],
		dataC:[]
	},
	data () {
		return {
			value: '',
			// userId:'',
			list:[
				{ name:'首页', url:'/?index=0' },
				{ name:'热卖榜单', url:'/?index=1' },
				{ name:'精选好物', url:'/?index=2' },
				{ name:'每日上线', url:'/?index=3' },
				{ name:'拼团购', url:'/?index=4' },
				// { name:'个人中心', url:'/order' },
			],
			QRcode:'',
		}
	},
	mounted() {
		// console.log(this.$cookie.get('userId'))
		// this.userId = this.$cookie.get('userId')
	},
	created() {
		this.getCode()
	},
	computed: {
		userId() {
			if(this.$cookie.get('uuid')){
				return this.$cookie.get('userId')
			}else{
				this.$store.commit('updateUserId','')
				this.$store.commit('updateRelationId','')
				
				this.$cookie.set('uuid','')
				this.$cookie.set('userId','')
				this.$cookie.set('relationId', '')
				this.$cookie.set('image_url', '')
				this.$cookie.set('nickName', '')
				this.$cookie.set('phone', '')
			}
		
			// return this.$store.state.userId
			
		},
	},
	methods:{
		goShoppingCar(url) {
			if(this.userId) {
				this.$router.push({
					path: url
				})
			} else {
				this.$router.push({
					path: '/login'
				})
			}

		},
		goHome() {
			if(this.$route.path == '/') {

			} else {
				this.$router.push({
					path: '/'
				})
			}

		},
		goAbute(url){
			this.$router.push({
				path: url
			})
		},
		goChat() {
			if(this.userId) {
				this.$http({
					url: this.$http.adornUrl('/chat/save'),
					method: 'post',
					data: this.$http.adornData({
						storeHead: "九条购兄自营店铺",
						storeId: "0",
						storeName: "",
						userId: this.$cookie.get('userId'),
						userName: this.$cookie.get('nickName'),
					})
				}).then(({data}) => {
					let returnData = data.data;
					this.$router.push({
						path: '/vueMchat?chatId='+ returnData.chatId
					})
				})
			} else {
				this.$router.push({
					path: '/login'
				})
			}
		},
		handleCommand(command) {
			this.$router.push({
				path: command
			})
		},
		sousuo(){
			if(this.value==''){
				// this.$message('搜索内容不能为空')
			}
		},
		getCode() {
			this.$http({
				url: this.$http.adornUrl('/common/type/280'),	//小程序二维码
				method: 'get',
			}).then(({data}) => {
				window.localStorage.setItem("QRcode",data.data.value);
				this.QRcode = data.data.value
			})
			
		},
		//退出登录
		quit() {
			this.$store.commit('updateUserId','')
			this.$store.commit('updateRelationId','')

			this.$cookie.set('uuid','')
			this.$cookie.set('userId','')
			this.$cookie.set('relationId', '')
			this.$cookie.set('image_url', '')
			this.$cookie.set('nickName', '')
			this.$cookie.set('phone', '')
			console.log(this.$route.path,'当前页路由')
			if(this.$route.path == '/') {
				this.$router.go(0)
			} else {
				this.$router.push({
					path: '/'
				})
			}

		}

	}
}
</script>
<style scoped="scoped">
.big-center{
	width: 100%;
	height: 24px;
	line-height: 24px;
	color: #999;
	font-size: 14px;
	background: #E6E6E6;
}
.center{
	width: 1200px;
	margin: 0 auto;
}
.top-left{
	text-align: left;

}
.top-left div{
	display: inline-block;
}
.logoname{
	/* width: 40%; */
}
.logins{
	width: 50%;
	text-align: center;
}
.logins span{
	color: #999;
	text-decoration:none;
}
.logins span:hover{
	color: #FF0D18;
	cursor: pointer;
}
.xian{
	margin: 0 10px;
}
.kong{
	width: 100%;
	height: 24px;
}
.top-right{
	text-align: right;
}
.top-right span{
	display: inline-block;
	margin-left: 20px;
	color: #999;
	text-decoration:none;
}
.top-right span:hover{
	color: #FF0D18;
	cursor: pointer;
}
.big-centers{
	width: 100%;
	height: 84px;
	/* line-height: 120px; */
}
.big-centers .center .cons{
	display: inline-block;
}
.left{
	width: 18%;
	text-align: left;
}
.left img{
	position: relative;
	top: 10px;
}

.cont{
	width: 20%;

}
.searchs{
	padding-top: 26px;
}

.search-list{
	text-align: left;
	font-size: 14px;
	color: #999;
	margin-top: 10px;
}
.search-list div{
	display: inline-block;
	width: 16%;
	cursor: pointer;
}
.one{
	color: #FF0D18;
}
.one .re{
	display: inline-block;
	font-size: 12px;
	border: 1px solid #FF0D18;
	/* width: 14px;
    height: 14px; */
	border-radius: 2px;
	background: #FFC1C1;
	padding: 0 2px;
	/* margin-right: 6px; */
}

.right{
	width: 12%;
	text-align: right;
	color: #FF2D55;
	font-size: 18px;
}
.myCars{
	position: relative;
	bottom: 0px;
	border: 2px solid #FF2D55;
	border-radius: 4px;
	width: 84%;
	text-align: center;
	height: 35px;
	line-height: 35px;
	margin-left: 16%;
	cursor: pointer;
}
.carimg{
	position: relative;
	top: 3px;
}

.el-input-group__append, .el-input-group__prepend{
	background: #FF2D55!important;
	color: #fff!important;
	border: 1px solid #FF2D55!important;
}
</style>



// WEBPACK FOOTER //
// src/components/head.vue